import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as common from '../../../../../../../../common'
import * as subcategory from '../subcategory'

export const RESOURCE = {
  payload: {
    modelId: subcategory.MODEL_ID,
    parentId: common.FaFunction.Category.Standard.Id.of(
      'EquipmentDepreciation',
    ),
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[,]}',
      [PartialId.Standard.create('code')]:
        common.FaFunction.Subcategory.Standard.Code.Building,
      [PartialId.Standard.create('descr')]:
        'Equipment Depreciation related to buildings',
      [PartialId.Standard.create('id')]:
        common.FaFunction.Subcategory.Standard.Id.create(
          common.FaFunction.Category.Standard.Code.EquipmentDepreciation,
          common.FaFunction.Subcategory.Standard.Code.Building,
        ),
      [PartialId.Standard.create('name')]: 'Building',
      [PartialId.Standard.create('position')]: 8,
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
